import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { DEFAULT_COLORS } from '../default-colors';

@Component({
  selector: 'vectronic-color-picker-window',
  templateUrl: './color-picker-window.component.html',
  styleUrls: ['./color-picker-window.component.scss'],
  imports: [CommonModule, MatInputModule],
})
export class ColorPickerWindowComponent {
  private dialogRef = inject(MatDialogRef<ColorPickerWindowComponent>);
  data: string = inject(MAT_DIALOG_DATA);
  result: string;

  defaultColors = DEFAULT_COLORS;
  color: string = DEFAULT_COLORS[0];

  constructor() {
    this.color = this.data;
  }

  changeColor(color: string) {
    this.color = color;
    this.dialogRef.close(this.color);
  }

  changeColorManual(color: string) {
    const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

    if (isValid) {
      this.color = color;
    }
  }

  toggleColors() {
    this.dialogRef.close(this.color);
  }
}
